/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2021 Priska Wermelinger & Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component, { type ComponentAttrs } from 'flarum/common/Component';
import icon from 'flarum/common/helpers/icon';
import type Mithril from 'mithril';
import editBookshelfAction from '../utils/editBookshelfAction';
import CreateBookshelfBtn from './CreateBookshelfBtn';
import type Bookshelf from '../../common/models/Bookshelf';

export interface BookshelvesListItemEmptyAttrs extends ComponentAttrs {
	onCreated: (bookshelf: Bookshelf) => void;
}

export default class BookshelvesListItemEmpty<
	CustomAttrs extends BookshelvesListItemEmptyAttrs = BookshelvesListItemEmptyAttrs,
> extends Component<CustomAttrs> {
	view(): Mithril.Children {
		const { onCreated } = this.attrs;

		return (
			<div className="BookshelvesListItem ListItem--empty">
				<div className="BookshelvesListItem-container BookshelvesListItem-link" onclick={() => editBookshelfAction(null, onCreated)}>
					<div className="BookshelvesListItem-button">
						<CreateBookshelfBtn onCreated={onCreated} />
						<div className="BookshelvesListItem-background">{icon('fas fa-books')}</div>
					</div>
				</div>
			</div>
		);
	}
}
